// Single global state module. Components read from `state`; URL reflects it.

import type { Airport } from "./types";

export const state = {
  airports: [] as Airport[],
  query: "",
  expanded: new Set<string>(),
  loaded: false,
};

// Fields searched by the text box.
function haystack(airport: Airport): string {
  return [airport.iata, airport.name, airport.city, airport.country]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

export function visibleAirports(): Airport[] {
  const needle = state.query.trim().toLowerCase();
  if (!needle) return state.airports;
  return state.airports.filter((airport) => haystack(airport).includes(needle));
}

export function toggleExpanded(iata: string): void {
  if (state.expanded.has(iata)) state.expanded.delete(iata);
  else state.expanded.add(iata);
}

// --- URL sync: search query in `q` ------------------------------------------

export function readUrl(): void {
  const params = new URLSearchParams(location.search);
  state.query = params.get("q") ?? "";
}

export function writeUrl(): void {
  const query = state.query.trim();
  const url = query ? `?q=${encodeURIComponent(query)}` : location.pathname;
  history.replaceState(null, "", url);
}
